import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "excel",
  "use": "excel-usage",
  "viewBox": "0 0 83.3 102.9",
  "content": "<symbol viewBox=\"0 0 83.3 102.9\" id=\"excel\"><path fill=\"#1f7447\" d=\"M56.9 30.4V14H18.1v75.1h52V30.4z\" /><path fill=\"#529943\" d=\"M70.1 30.4L56.9 14v16.4z\" /><path fill=\"none\" d=\"M21.6 46.5h45v16.2h-45z\" /><text transform=\"translate(21.646 57.708)\" font-size=\"15\" font-family=\"Roboto\" fill=\"#fff\">EXCEL</text></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/excel.svg
// module id = sWjn
// module chunks = 1